module.exports = "<section ng-show=\"selected\" class=\"step\" ng-transclude></section>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/blur_admin/src/app/theme/components/baWizard/baWizardStep.html
// module id = 808
// module chunks = 2